import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const laborTemplateApi = AiseaApiFactory.get("enterpriseLaborTemplate");
const crewsApi = AiseaApiFactory.get("enterpriseCrew");
const laborApi = AiseaApiFactory.get("enterpriseCrewLabor");

export default {

  async fetchCrew ({ state, commit }) {
    const res = await crewsApi.fetch(state.enterpriseCrewId);
    commit("SET_CREW", res.data)
  },

  async addLabor ({ state }, payload) {
    let res = null;
    res = await laborApi.add(state.enterpriseCrewId, payload);
    return res;
  },

  async updateLabor ({ state }, payload) {
    let res = null;
    const enterpriseCrewLaborId = payload.id;
    res = await laborApi.update(state.enterpriseCrewId, enterpriseCrewLaborId, payload);
    return res;
  },

  async fetchLaborPeriodList({state, commit}, payload) {
    const res = await laborApi.search(state.enterpriseCrewId, payload);
    if(!res.status || !("crew_labors" in res.data))  {
      commit("SET_LABORS", []);
      return;
    }
    commit("SET_LABORS", res.data.crew_labors);
  },

  async fetchTemplateList ({ commit }, payload) {
    const res = await laborTemplateApi.search(payload);
    commit("SET_TEMPLATES", res.data.templates);
  },

};